/** ----------------------------------------
     State
 ---------------------------------------- */

import router from '@router/router';

const state = () => {
    return {
        data: [
            {
                subtitle: 'Making the magic happen',
                title: 'Development',
                members: [
                    {
                        name: 'Sander Hidding',
                        role: 'Lead Developer',
                        email: 'sander@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5a3a2d98cb16433309099952fa2c39dffe40703ca7e20.png',
                    },
                    {
                        name: 'Giovanni Marchese',
                        role: 'Backend Developer',
                        email: 'giovanni@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5bcde17676b53885b6ef6ff09a01671af2497480f31a8.png',
                    },
                    {
                        name: 'Ted Godyla',
                        role: 'Full Stack Developer',
                        email: 'ted@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5c3da6758e3a181a768b90cfe859734280fb72e768553.png',
                    }
                ]
            },
            {
                subtitle: 'Spicing up things',
                title: 'Creatives',
                type: 'split',
                members: [
                    {
                        name: 'Walewijn den Boer',
                        role: 'Senior Designer',
                        email: 'walewijn@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_57e8d07268605a9ce397758f7301b5ebd81c5ad04b6d3.png',
                    },
                    {
                        name: 'Roland Cos',
                        role: 'Designer',
                        email: 'roland@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_57e8d1ef3d7db51a9bdc6059653872d6177adbe7a472b.png',
                    },
                    {
                        name: 'Leendert van Duijvenbode',
                        role: 'Designer',
                        email: 'leendert@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5e00d97970188638f15e7ede7fc9298f6f71ea8f7faba.png',
                    }
                ]
            },
            {
                subtitle: 'We make your life easier',
                title: 'Project Management',
                type: 'split',
                members: [
                    {
                        name: 'Justine de Bruijn',
                        role: 'Senior Projectmanager',
                        email: 'justine@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5bc9aed189f3e6a78a69d568ebd329edcde0912b236a2.png',
                    },
                    {
                        name: 'Yira Rodriguez Garcia',
                        role: 'Projectmanager',
                        email: 'yira@vruchtvlees.com',
                        linkedin: 'https://www.linkedin.com/in/sanderhidding/',
                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/500x500_5bc9af2b890aec8ce71d211893f4eac834635c0af409e.png',
                    }
                ]
            }
        ]
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;